function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Sfumatura_senza_nome_28);}.cls-2{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Sfumatura_senza_nome_28",
  x1: 160.92,
  y1: 249.35,
  x2: 159.12,
  y2: 2.35,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#00cf92"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.27,
  stopColor: "#00c4a3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.81,
  stopColor: "#00a7ce"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#009cde"
})));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "logo2");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Livello_2",
  "data-name": "Livello 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Livello_1-2",
  "data-name": "Livello 1"
}, /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 160,
  cy: 123.5,
  r: 123.5
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M147.19,210.55a12.14,12.14,0,0,1-8.62-3.56L58.28,126.7a2,2,0,0,0-2.87,0L8.66,173.44a5.07,5.07,0,0,1-7.17-7.18l46.74-46.74a12.18,12.18,0,0,1,17.23,0l80.29,80.29a2,2,0,0,0,2.87,0l92.93-92.93a5.08,5.08,0,0,1,7.18,7.18L155.8,207A12.1,12.1,0,0,1,147.19,210.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M185.56,247a30.26,30.26,0,1,1,30.26-30.26A30.29,30.29,0,0,1,185.56,247Zm0-50.36a20.11,20.11,0,1,0,20.11,20.1A20.13,20.13,0,0,0,185.56,196.64Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M253.46,179.1a30.26,30.26,0,1,1,30.25-30.25A30.29,30.29,0,0,1,253.46,179.1Zm0-50.36a20.11,20.11,0,1,0,20.1,20.11A20.13,20.13,0,0,0,253.46,128.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M136.53,199.91a12.23,12.23,0,0,1-8.61-3.56L72.53,141a12.18,12.18,0,0,1,0-17.24L182.24,14.07a5.08,5.08,0,0,1,8.11,1.28l36.3,70.81a12.17,12.17,0,0,1-1.45,13.31h0l-79.28,96a12.24,12.24,0,0,1-8.81,4.42Zm48-173.73L79.7,131a2,2,0,0,0,0,2.87l55.4,55.33a2,2,0,0,0,1.53.59,2.06,2.06,0,0,0,1.47-.74l79.27-96a2,2,0,0,0,.24-2.22Zm36.8,70.06h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M143.26,158a10.56,10.56,0,0,1-7.52-3.11L109,128.06a10.63,10.63,0,0,1,15-15l26.79,26.8a10.61,10.61,0,0,1,0,15h0A10.52,10.52,0,0,1,143.26,158ZM116.46,118a2.46,2.46,0,0,0-1.77.74,2.5,2.5,0,0,0,0,3.54l26.79,26.8a2.59,2.59,0,0,0,3.55,0h0a2.5,2.5,0,0,0,0-3.55l-26.79-26.79A2.5,2.5,0,0,0,116.46,118Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M166.72,134.5a10.62,10.62,0,0,1-7.52-3.11L132.41,104.6a10.63,10.63,0,0,1,15-15l26.79,26.8a10.63,10.63,0,0,1-7.51,18.14Zm-26.8-39.93a2.51,2.51,0,0,0-1.77,4.28l26.79,26.8a2.51,2.51,0,0,0,3.55,0,2.54,2.54,0,0,0,.74-1.78,2.5,2.5,0,0,0-.74-1.77L141.7,95.31A2.51,2.51,0,0,0,139.92,94.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M190.65,110.57a10.56,10.56,0,0,1-7.52-3.11L156.34,80.67a10.63,10.63,0,0,1,15-15l26.79,26.8a10.63,10.63,0,0,1,0,15h0A10.55,10.55,0,0,1,190.65,110.57Zm-26.8-39.93a2.52,2.52,0,0,0-1.77,4.29l26.79,26.79a2.57,2.57,0,0,0,3.55,0h0a2.52,2.52,0,0,0,0-3.55L165.63,71.38A2.52,2.52,0,0,0,163.85,70.64Z"
})));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 283.71 247",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.18aaf2bb.svg";
export { ForwardRef as ReactComponent };